import {Directive, Input}                  from '@angular/core';
import {MatMenuPanel, MatMenuTrigger}      from '@angular/material/menu';

@Directive({
    selector: `[ngxMatMenuTriggerFor]`,
    exportAs: 'ngxMatMenuTrigger',
    standalone: false
})
export class PopoverDirective extends MatMenuTrigger
{
    override _handleClick(event: MouseEvent): void
    {
        // Nothing to do
    }

    @Input('ngxMatMenuTriggerFor')
    override get menu(): MatMenuPanel | null
    {
        return super.menu;
    }

    override set menu(menu: MatMenuPanel | null)
    {
        super.menu = menu;
    }
}